import Stack from '@mui/material/Stack';

export default function FormFieldsStack({
	direction = 'column',
	spacing = 3,
	children,
	...props
}) {
	return (
		<Stack direction={direction} spacing={spacing} {...props}>
			{children}
		</Stack>
	);
}
